
import { defineComponent } from 'vue';

/**
 * Icone de seta.
 * @displayName IconSuccess [Componente do UseIcon]
 */
export default defineComponent({
    name: 'IconSuccess',
    props: {
        size: {
            type: [String, Number],
            default: 22,
        },
        color: {
            type: String,
            default: 'white',
        },
    },
});
